import { useDeleteTeamMutation } from 'src/api/redux/teams';

export const useDeleteTeam = () => {
  const [deleteTeamMutation, { isLoading: isDeleting, error }] =
    useDeleteTeamMutation();

  const handleDeleteTeam = async (id: string) => {
    try {
      await deleteTeamMutation(id).unwrap();
      return true;
    } catch (err) {
      return false;
    }
  };

  return {
    deleteTeam: handleDeleteTeam,
    isDeleting,
    error: error ? { message: (error as { data?: { detail?: string } })?.data?.detail || 'An error occurred' } : null,
  };
};

export default useDeleteTeam;
